import { render, staticRenderFns } from "./StatusCards.vue?vue&type=template&id=7b86fa2b&scoped=true"
import script from "./StatusCards.vue?vue&type=script&lang=js"
export * from "./StatusCards.vue?vue&type=script&lang=js"
import style0 from "./StatusCards.vue?vue&type=style&index=0&id=7b86fa2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86fa2b",
  null
  
)

export default component.exports